import { hexToRgb, hexToRgba } from "@/utils/color.js";

function lighten(rgb, percent = 0.5) {
  return `rgba(${rgb},${percent})`;
}

export function configTheme(brandColor = "#ffca40", fontColor = "#000") {
  const brandColorRgb = hexToRgb(brandColor);
  const regex = /\(([^)]*)\)/;
  const colorNumbers = brandColorRgb.match(regex)[1];
  let styleStr = `
    :root {
      --brandColor: ${brandColor};
      --brandColor10: ${lighten(colorNumbers, 0.1)};
      --brandColor40: ${lighten(colorNumbers, 0.4)};
      --brandColor70: ${lighten(colorNumbers, 0.7)};
      --fontColor: ${fontColor};
      // --fontColor: #5D67ED;
    }
    html {
      --antd-wave-shadow-color: var(--brandColor);
    }
    body, h1, h2, h3, h4, h5, h6{
      // color: var(--fontColor);
    }

    @media (max-width: 768px) {
      .ant-tabs-bar .ant-tabs-tab.ant-tabs-tab-active{
        background: transparent !important;
        border-bottom: 4px solid var(--brandColor) !important;
      }
      .loyalty-top{
        background: transparent !important;
      }
    }
  `;

  const style = document.createElement("style");
  style.type = "text/css";
  style.innerHTML = styleStr;
  document
    .getElementsByTagName("HEAD")
    .item(0)
    .appendChild(style);
}



// WEBPACK FOOTER //
// ./src/utils/theme.js